<h5>
  Views
  <span *ngIf="true" (click)="showEdits()" class="block-icon"><mat-icon aria-hidden="false" aria-label="Settings">settings</mat-icon></span>
</h5>

<div mat-dialog-content>


  <form [formGroup]="settingsForm" novalidate (ngSubmit)="(false)">
    <div class="row">
      <div class="col-md-12">
        <mat-form-field class="w-100">
          <input
            (change)="$event.target.select()"
            matInput
            type="text"
            formControlName="viewName"
            class="text-right"
            placeholder="Name of a new View"
            autocomplete="off"
          />
        </mat-form-field>
      </div>
    </div>
  </form>
</div>

<div mat-dialog-actions>
  <div class="row w-100">
    <div class="col-md-6">
      <button mat-button (click)="onDismiss()">Cancel</button>
    </div>
    <div class="col-md-6">
      <button
        class="ml-4"
        mat-raised-button
        [disabled]="disabled"
        [color]="'glb_greenbtn'"
        (click)="onConfirm()"
      >
        Save New
      </button>
    </div>
  </div>
</div>

